export default function getClientData() {
  return {
    javaEnabled: false,
    language: navigator.language,
    screenHeight: screen.height,
    screenWidth: screen.width,
    screenColorDepth: screen.colorDepth,
    timezone: new Date().getTimezoneOffset(),
  }
}
